import React, { useEffect, useState } from 'react'
import { BsThreeDots } from 'react-icons/bs'
import { BiSolidLock } from 'react-icons/bi'
import { Button, Dropdown, Input, InputNumber, message, Select, Spin } from 'antd'
import { Link } from 'react-router-dom'
import ApexChart from '../../../components/chart'
import { useDispatch } from 'react-redux'
import { changeHeader } from '../../../redux/reducer/headerSlice'
import { PiCoinFill, PiShoppingCartBold } from 'react-icons/pi'
import { useLocation } from 'react-router-dom'
import handlePost from '../../../utils/Post'
import { BASE_URL } from '../../../utils/config'
import axios from 'axios'
import QRCode from "react-qr-code"
import handleGet from '../../../utils/Get'
import image from '../../../assests/images/Arrow 2.png'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

const AssetsManage = () => {
    const user = JSON.parse(localStorage.getItem('user'))
    const dispatch = useDispatch()
    const location = useLocation()
    const data = location?.state

    const [buttonManage, setButtonManage] = useState({ recieve: true, send: false, exchange: false })
    const [sendData, setSendData] = useState({ to_address: '', asset_id: data?.id, amount: '' })
    const [loading, setLoading] = useState(false)
    const [graphData, setGraphData] = useState('')
    const [transaction, setTransaction] = useState('')
    const { t } = useTranslation()
    const { welcomeback } = t("dashboard", { returnObjects: true })
    const [NotesData, setNotesData] = useState([])

    useEffect(() => {
        const fetchUser = async () => {
            const res = await handleGet(`${BASE_URL}get/user/detail/${user?.id}`)
            if (res) setNotesData(res?.user)
        }
        fetchUser()
    }, [welcomeback])

    useEffect(() => {
        dispatch(changeHeader(`${user.name}, ${welcomeback}`))
    }, [user, welcomeback])

    useEffect(() => {
        const fetchBitcoinData = async () => {
            try {
                const response = await axios.get(
                    `https://api.coingecko.com/api/v3/coins/${(data?.name).toLowerCase() === 'xrp'
                        ? 'xrp-classic-new'
                        : (data?.name).toLowerCase() === 'fiat'
                            ? 'tether'
                            : (data?.name).toLowerCase()
                    }/market_chart?vs_currency=usd&days=120&interval=daily`
                )
                setGraphData(response?.data?.prices)
            } catch (error) {
                console.log(error.message)
            }
        }

        const fetchTransactions = async () => {
            const response = await handleGet(`${BASE_URL}active/user/transaction`)
            setTransaction(response?.transactions)
        }

        fetchTransactions()
        fetchBitcoinData()
    }, [])

    const [selectedOption, setSelectedOption] = useState('IBAN')
    const handleChange = (selected) => setSelectedOption(selected)

    const paymentOptions = [
        { value: 'IBAN', label: 'IBAN' },
        { value: 'BSB', label: 'BSB/Acc Number' },
        { value: 'eTransfer', label: 'E-Transfer' },
    ]

    const [formData, setFormData] = useState({
        IBAN: { means_of_transaction: 'IBAN', fullname: '', bank_name: '', iban_number: '' },
        BSB: { means_of_transaction: 'BSB/Acc Number', bsb_number: '', account_number: '', fullname: '', bank_name: '' },
        eTransfer: { means_of_transaction: 'E-Transfer', fullname: '', email: '', bank_name: '' },
    })

    const handleInputChange = (e, method, field) => {
        const value = e.target.value
        setFormData(prev => ({ ...prev, [method]: { ...prev[method], [field]: value } }))
    }

    const handleSend = async () => {
        if (NotesData?.detail?.is_send === "false") {
            message.info(NotesData?.detail?.send)
            return
        }
        setLoading(true)
        try {
            await handlePost(`${BASE_URL}user/transaction/send`, sendData)
            setSendData({ to_address: '', asset_id: data?.id, amount: '' })
        } catch (err) {
            console.log(err)
        } finally {
            setLoading(false)
        }
    }

    const [flatAmount, setAmount] = useState('')

    const Handleflatdep = async () => {
        if (NotesData?.detail?.is_send === "false") {
            message.info(NotesData?.detail?.send)
            return
        }
        const maindata = {
            amount: flatAmount,
            sent_at: null, hidden: null, txt_id: null,
            from_address: null, note: null,
            user_id: user?.id, asset_id: data?.id,
            type: 'withdraw',
            ...formData[selectedOption],
        }
        setLoading(true)
        try {
            await handlePost(`${BASE_URL}transaction/make/flatdeposit`, maindata)
            setFormData('')
            setAmount('')
        } catch (err) {
            console.log(err)
        } finally {
            setLoading(false)
        }
    }

    const tabs = [
        { key: 'recieve', label: 'Receive' },
        { key: 'send', label: 'Send' },
        { key: 'exchange', label: 'Exchange' },
    ]

    const activeTab = Object.keys(buttonManage).find(k => buttonManage[k])

    return (
        <div className="w-full h-full flex flex-col lg:flex-row gap-5 overflow-x-hidden">

            {/* ── Left: Asset Info Card ── */}
            <div className="w-full lg:w-[300px] lg:flex-shrink-0 h-fit rounded-[26px] px-3 py-3 bg-[#1e293b] shadow-[0_22px_60px_rgba(15,23,42,0.9)] p-6">

                {/* Header */}
                <div className="flex justify-between items-center mb-5">
                    <div className="flex items-center gap-3">
                        <div className="w-12 h-12 rounded-2xl bg-[#6e48ff]/20 flex items-center justify-center shadow-[0_8px_20px_rgba(110,72,255,0.25)]">
                            <img className="w-7 h-7" src={data?.symbol} alt={data?.name} />
                        </div>
                        <div>
                            <p className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold">Asset</p>
                            <p className="text-base font-bold text-slate-100">Manage {data?.name}</p>
                        </div>
                    </div>
                    <Dropdown
                        className="text-white"
                        trigger={['click']}
                        placement="bottomRight"
                        dropdownRender={() => (
                            <div className="w-64 p-2 bg-[#1e293b] border border-slate-700 rounded-2xl shadow-2xl">
                                <div className="flex items-center gap-3 p-3 rounded-xl cursor-pointer hover:bg-slate-700/50 transition">
                                    <PiCoinFill className="text-[#6e48ff]" size={20} />
                                    <div>
                                        <p className="text-sm font-semibold text-slate-100">Exchange</p>
                                        <p className="text-xs text-slate-500">Exchange your assets</p>
                                    </div>
                                </div>
                                <div className="flex items-center gap-3 p-3 rounded-xl cursor-pointer hover:bg-slate-700/50 transition">
                                    <PiShoppingCartBold className="text-emerald-400" size={20} />
                                    <div>
                                        <p className="text-sm font-semibold text-slate-100">Buy Crypto</p>
                                        <p className="text-xs text-slate-500">Buy with card or bank</p>
                                    </div>
                                </div>
                            </div>
                        )}
                    >
                        <button className="w-9 h-9 rounded-xl bg-slate-700/60 flex items-center justify-center text-slate-300 hover:bg-slate-600 transition hover:rotate-90 duration-300">
                            <BsThreeDots size={18} />
                        </button>
                    </Dropdown>
                </div>

                {/* Balance */}
                <div className="rounded-2xl bg-gradient-to-br from-[#7b5cff] to-[#5b3df5] p-5 mb-5 shadow-[0_12px_30px_rgba(110,72,255,0.35)]">
                    <p className="text-xs uppercase tracking-[0.2em] text-indigo-200 font-semibold mb-1">Asset Balance</p>
                    <p className="text-3xl font-bold text-white">{data?.amount}</p>
                    <p className="text-indigo-200 text-sm mt-1">{data?.short_name}</p>
                </div>

                {/* Meta info */}
                <div className="space-y-3">
                    {[
                        { label: 'Status', value: 'Active', valueClass: 'text-emerald-400' },
                        { label: 'Date', value: dayjs().format('MMM DD[th], YYYY'), valueClass: 'text-slate-400' },
                        {
                            label: 'Security', valueClass: 'text-slate-400',
                            custom: (
                                <span className="flex items-center gap-1.5 text-slate-400 text-sm">
                                    <BiSolidLock className="bg-[#6e48ff] text-white rounded-md w-5 h-5 p-0.5" />
                                    AES-256
                                </span>
                            )
                        },
                    ].map(({ label, value, valueClass, custom }) => (
                        <div key={label} className="flex justify-between items-center py-2.5 border-b border-slate-700/60 last:border-0">
                            <p className="text-sm text-slate-500 font-medium">{label}</p>
                            {custom || <p className={`text-sm font-semibold ${valueClass}`}>{value}</p>}
                        </div>
                    ))}
                </div>
            </div>

            {/* ── Right: Action Card ── */}
            <div className="flex-1 min-w-0 rounded-[26px] px-3 py-3 bg-[#1e293b] shadow-[0_22px_60px_rgba(15,23,42,0.9)] p-6 h-fit">

                {/* Tab switcher */}
                <div className="flex gap-2 mb-6 bg-slate-900/60 rounded-2xl p-1">
                    {tabs.map(tab => (
                        <button
                            key={tab.key}
                            onClick={() => setButtonManage({ recieve: false, send: false, exchange: false, [tab.key]: true })}
                            className={`flex-1 py-2 rounded-xl text-sm font-semibold transition-all duration-200 ${
                                activeTab === tab.key
                                    ? 'bg-[#6e48ff] text-white shadow-[0_4px_14px_rgba(110,72,255,0.4)]'
                                    : 'text-slate-400 hover:text-slate-200'
                            }`}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>

                {/* ── RECEIVE tab ── */}
                {buttonManage.recieve && (
                    <div className="flex flex-col items-center gap-4">
                        <div className="rounded-2xl bg-white p-4 shadow-[0_8px_30px_rgba(0,0,0,0.3)]">
                            {data?.address ? (
                                <QRCode size={140} value={data?.address} viewBox="0 0 128 128" />
                            ) : (
                                <div className="w-36 h-36 bg-slate-200 rounded-xl" />
                            )}
                        </div>

                        <div className="w-full rounded-2xl bg-slate-900/60 border border-slate-700/60 px-4 py-3 text-center">
                            <p className="text-xs text-slate-500 font-semibold uppercase tracking-widest mb-1">
                                {data?.name} Address
                            </p>
                            <p className="text-sm text-slate-300 break-all leading-relaxed">
                                {data?.address || 'Contact support for address'}
                            </p>
                        </div>

                        {!data?.address && (
                            <button disabled className="w-full py-2.5 rounded-xl bg-slate-700/50 text-slate-400 text-sm font-semibold cursor-not-allowed">
                                Generating Address...
                            </button>
                        )}

                        <p className="text-xs text-slate-500 text-center leading-relaxed">
                            Please wait while we generate your address. This may take up to an hour.
                        </p>
                    </div>
                )}

                {/* ── SEND tab ── */}
                {buttonManage.send && (
                    <div className="mt-1">
                        {data?.name === 'Fiat' ? (
                            <div className="space-y-3">
                                <Select
                                    className="w-full"
                                    value={selectedOption}
                                    onChange={handleChange}
                                    options={paymentOptions}
                                    size="large"
                                />

                                {/* Amount — common to all methods */}
                                <div>
                                    <label className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-1.5 block">Amount</label>
                                    <Input
                                        value={flatAmount}
                                        placeholder="0.00"
                                        size="large"
                                        onChange={(e) => setAmount(e.target.value)}
                                        className="rounded-xl"
                                    />
                                </div>

                                {selectedOption === 'IBAN' && (
                                    <>
                                        <div>
                                            <label className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-1.5 block">Full Name</label>
                                            <Input value={formData?.IBAN?.fullname} placeholder="Full Name" size="large" onChange={(e) => handleInputChange(e, 'IBAN', 'fullname')} className="rounded-xl" />
                                        </div>
                                        <div>
                                            <label className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-1.5 block">IBAN Number</label>
                                            <Input value={formData?.IBAN?.iban_number} placeholder="Enter IBAN number" size="large" onChange={(e) => handleInputChange(e, 'IBAN', 'iban_number')} className="rounded-xl" />
                                        </div>
                                        <div>
                                            <label className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-1.5 block">Bank Name</label>
                                            <Input value={formData?.IBAN?.bank_name} placeholder="Bank Name" size="large" onChange={(e) => handleInputChange(e, 'IBAN', 'bank_name')} className="rounded-xl" />
                                        </div>
                                    </>
                                )}

                                {selectedOption === 'BSB' && (
                                    <>
                                        <div>
                                            <label className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-1.5 block">BSB Number</label>
                                            <Input value={formData?.BSB?.bsb_number} placeholder="BSB Number" size="large" onChange={(e) => handleInputChange(e, 'BSB', 'bsb_number')} className="rounded-xl" />
                                        </div>
                                        <div>
                                            <label className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-1.5 block">Account Number</label>
                                            <Input value={formData?.BSB?.account_number} placeholder="Account Number" size="large" onChange={(e) => handleInputChange(e, 'BSB', 'account_number')} className="rounded-xl" />
                                        </div>
                                        <div>
                                            <label className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-1.5 block">Full Name</label>
                                            <Input value={formData?.BSB?.fullname} placeholder="Full Name" size="large" onChange={(e) => handleInputChange(e, 'BSB', 'fullname')} className="rounded-xl" />
                                        </div>
                                        <div>
                                            <label className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-1.5 block">Bank Name</label>
                                            <Input value={formData?.BSB?.bank_name} placeholder="Bank Name" size="large" onChange={(e) => handleInputChange(e, 'BSB', 'bank_name')} className="rounded-xl" />
                                        </div>
                                    </>
                                )}

                                {selectedOption === 'eTransfer' && (
                                    <>
                                        <div>
                                            <label className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-1.5 block">Full Name</label>
                                            <Input value={formData?.eTransfer?.fullname} placeholder="Full Name" size="large" onChange={(e) => handleInputChange(e, 'eTransfer', 'fullname')} className="rounded-xl" />
                                        </div>
                                        <div>
                                            <label className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-1.5 block">Email</label>
                                            <Input value={formData?.eTransfer?.email} placeholder="Email" size="large" onChange={(e) => handleInputChange(e, 'eTransfer', 'email')} className="rounded-xl" />
                                        </div>
                                        <div>
                                            <label className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-1.5 block">Bank Name</label>
                                            <Input value={formData?.eTransfer?.bank_name} placeholder="Bank Name" size="large" onChange={(e) => handleInputChange(e, 'eTransfer', 'bank_name')} className="rounded-xl" />
                                        </div>
                                    </>
                                )}

                                <button
                                    onClick={Handleflatdep}
                                    disabled={loading}
                                    className="mt-2 w-full py-3 rounded-2xl text-white font-bold text-base
                                        bg-gradient-to-r from-[#734aff] to-[#5b34ea] hover:opacity-90 transition
                                        disabled:opacity-50 disabled:cursor-not-allowed shadow-[0_8px_30px_rgba(110,72,255,0.4)]"
                                >
                                    {loading ? 'Sending...' : `Send ${data?.short_name}`}
                                </button>
                            </div>
                        ) : (
                            <div className="space-y-4">
                                <div>
                                    <label className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-1.5 block">To Address</label>
                                    <Input
                                        placeholder="Enter recipient address"
                                        value={sendData?.to_address}
                                        onChange={e => setSendData({ ...sendData, to_address: e.target.value })}
                                        size="large"
                                        className="rounded-xl"
                                    />
                                </div>

                                <div>
                                    <label className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-1.5 block">Amount</label>
                                    <div className="flex gap-2">
                                        <input
                                            type="number"
                                            placeholder="0.00"
                                            value={sendData?.amount}
                                            onChange={e => setSendData({ ...sendData, amount: e.target.value })}
                                            className="flex-1 min-w-0 bg-slate-900/60 border border-slate-700 rounded-xl px-4 py-2.5 text-slate-100 placeholder-slate-500 outline-none focus:border-[#6e48ff] transition text-base"
                                            style={{ appearance: 'textfield', MozAppearance: 'textfield', WebkitAppearance: 'none' }}
                                        />
                                        <button
                                            onClick={() => setSendData({ ...sendData, amount: data?.amount })}
                                            className="px-4 py-2.5 rounded-xl bg-[#6e48ff]/20 text-[#a78bfa] font-semibold text-sm hover:bg-[#6e48ff]/30 transition border border-[#6e48ff]/30"
                                        >
                                            Max
                                        </button>
                                    </div>
                                </div>

                                <p className="text-xs text-slate-500 leading-relaxed bg-slate-900/40 rounded-xl px-3 py-2.5 border border-slate-700/50">
                                    ⚡ Funds will be sent for approval by administrator.
                                </p>

                                <button
                                    onClick={handleSend}
                                    disabled={loading}
                                    className="w-full py-3 rounded-2xl text-white font-bold text-base
                                        bg-gradient-to-r from-[#734aff] to-[#5b34ea] hover:opacity-90 transition
                                        disabled:opacity-50 disabled:cursor-not-allowed shadow-[0_8px_30px_rgba(110,72,255,0.4)]"
                                >
                                    {loading ? 'Sending...' : `Send ${data?.short_name}`}
                                </button>
                            </div>
                        )}
                    </div>
                )}

                {/* ── EXCHANGE tab ── */}
                {buttonManage.exchange && (
                    <div className="mt-1 flex flex-col items-center gap-4">
                        <div className="w-full rounded-2xl bg-slate-900/60 border border-slate-700/60 p-5 text-center">
                            <div className="w-14 h-14 rounded-2xl bg-[#6e48ff]/20 flex items-center justify-center mx-auto mb-3">
                                <PiCoinFill className="text-[#a78bfa]" size={28} />
                            </div>
                            <p className="text-slate-300 text-sm font-medium">
                                Swap your {data?.name} for any other asset instantly.
                            </p>
                        </div>
                        <Link to="/user/swapcrypto" className="w-full">
                            <button className="w-full py-3 rounded-2xl text-white font-bold text-base
                                bg-gradient-to-r from-[#734aff] to-[#5b34ea] hover:opacity-90 transition
                                shadow-[0_8px_30px_rgba(110,72,255,0.4)]">
                                Go to Exchange →
                            </button>
                        </Link>
                    </div>
                )}
            </div>


        </div>
    )
}

export default AssetsManage